import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorHandlerService, HandleError } from '../shared/http-error-handler.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ForuscareService } from '../foruscare/foruscare.service';
import { Account } from '../../models/account';
import { serviceWorkflow } from '../../models/service';
import { Device } from '../../models/device';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  private handleError: HandleError;
  constructor(
    public http: HttpClient,
    public fourscareService: ForuscareService,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handleError = httpErrorHandler.createHandleError('Device Service');
  }

  updateDevice(device: Device, deviceId: string): Observable<any> {
    var url = "/admin/device/";
    return this.http.put<any>(this.fourscareService.baseAuthURL() + url + deviceId, device)
      .pipe(
        catchError(this.handleError('device updation'))
      );
  }

  getAllDevices(accountId): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/admin/device/getDevicesByAccount/"+accountId)
      .pipe(
        catchError(this.handleError('listing existing accounts'))
      );
  }

  getAllDevicesPaging(count, offset): Observable<any> {
    return this.http.get<any>(this.fourscareService.baseAuthURL() + "/admin/device/?count=" + count + "&offset=" + offset)
      .pipe(
        catchError(this.handleError('listing existing accounts'))
      );
  }

  addDevice(device: Device): Observable<any> {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/admin/device", device)
      .pipe(
        catchError(this.handleError('device creation'))
      );
  }

  assignDevice(deviceId, orgId, accountId) {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/devices", deviceId)
      .pipe(
        catchError(this.handleError('device creation'))
      );
  }

  unAssignDevice(deviceId, orgId, accountId) {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/devices", deviceId)
      .pipe(
        catchError(this.handleError('device creation'))
      );
  }

  updateDeviceStatus(deviceId, orgId, accountId): any {
    return this.http.post<any>(this.fourscareService.baseAuthURL() + "/devices", deviceId)
      .pipe(
        catchError(this.handleError('device creation'))
      );
  }


}
